// SAB-578: the one real, engine-scored game (Geno Smith, 2025 Wk 2 vs LAC), moved
// here from SocialProof to sit beside the live Trash Scoring card in How It Works.
// A verifiable box score is stronger proof than a hypothetical.
//
// Every number is real. +93 is the engine's stored trash_points
// (nfl_player_game_stats), reconciling to model 2.2 as: 43 pass attempts +43,
// 3 INT +30, 3 sacks +9, 3 batted passes +3, 5 rush attempts +5, team loss bonus
// +3. DO NOT change it.
//
// SAB-578 item 2: +93 is trash points BEFORE offsets. This game's anti_points are
// -31.4 (24 completions -24, 180 pass yards -5.4, 20 rush yards -2), so the actual
// SAB PTS is 61.6. The qualifier subtext below keeps a reader from reading +93 as
// the final score.
export function RealGameCard() {
  return (
    <div>
      <div className="font-display text-[11px] uppercase tracking-[0.06em] font-bold text-muted-foreground mb-4">
        A real game with our scoring!
      </div>
      <div
        className="rounded-xl border border-[hsl(0_84%_60%_/_0.35)] bg-card p-5"
        style={{ boxShadow: 'var(--shadow-sm)' }}
      >
        {/* Player + game context (all real) */}
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="font-display font-extrabold text-[19px] text-foreground">
              Geno Smith
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">
              QB · 2025 Wk 2 vs LAC · L 20&ndash;9
            </div>
          </div>
          <span className="inline-flex items-center gap-1.5 text-[11px] font-display font-bold uppercase tracking-[0.06em] text-damage shrink-0">
            <span className="w-[7px] h-[7px] rounded-full bg-damage" />
            Real game
          </span>
        </div>

        {/* Real box-score line (nfl_player_game_stats, 2025 Wk 2) */}
        <div className="text-sm text-muted-foreground mt-3">
          24/43 · 180 yds · 0 TD · 3 INT · 3 sacks · 3 batted passes
        </div>

        {/* The engine's canonical trash total (stored trash_points) */}
        <div className="flex items-center justify-between border-t border-border pt-4 mt-4">
          <span className="font-display font-bold text-sm uppercase tracking-[0.05em] text-muted-foreground">
            Trash total
          </span>
          <span className="font-varsity text-gradient-sabotage text-[54px] leading-none tabular-nums">
            +93
          </span>
        </div>

        {/* SAB-578 item 2: offsets qualifier. */}
        <p className="text-xs text-muted-foreground/80 mt-3">
          Trash points, before offsets. Completions and yards score against you.
        </p>
      </div>
    </div>
  );
}

export default RealGameCard;
